
import { Component, Watch } from 'nuxt-property-decorator'
import BasePage from '../base/BasePage.vue'
import LifespanAwareContentWrapper from '../wrappers/LifespanAwareContentWrapper'

@Component({
  name: 'PtContentPage',
  components: { LifespanAwareContentWrapper },
})
export default class PtContentPage extends BasePage {
  created () {
    this.$store.commit('Page/setPageType', 'ContentPage')
  }

  @Watch('$store.state.Locations.savedLocations', { deep: true, immediate: true })
  private async savedLocationsChange () : Promise<void> {
    this.$store.commit('LocationOnlineAppointment/set', await this.getOnlineAppointmentLink())
    this.$store.commit('ToolbarElements/setOnlineAppointmentLink', await this.getOnlineAppointmentLink(true))
  }
}
